import { SignIn as ClerkSignIn } from '@clerk/clerk-react';

export default function SignIn() {
  return (
    <div className="flex min-h-screen">
      {/* Left Side - Branded Section */}
      <div className="hidden lg:flex lg:w-1/2 bg-gradient-to-br from-brand-navy to-[#0a2f6b] p-12 flex-col justify-between">
        <div>
          <img
            src="https://static.wixstatic.com/media/28bda8_155c86a5b5f341c7839ba26980f0aea4~mv2.png/v1/fill/w_276,h_128,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/GB%20logo%20copy.png"
            alt="GlobalBridge"
            className="h-12 object-contain mix-blend-lighten brightness-200 mb-16"
          />

          <div className="text-white space-y-6">
            <h1 className="text-4xl font-bold leading-tight">
              Welcome to GlobalBridge<br />Intelligence Suite
            </h1>
            <p className="text-xl text-blue-100">
              Your platform for sales analytics, inventory management, and marketplace growth.
            </p>

            <div className="mt-12 space-y-4">
              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Comprehensive Analytics</h3>
                  <p className="text-sm text-blue-200">Track sales, returns, and performance across all your marketplaces</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Inventory Management</h3>
                  <p className="text-sm text-blue-200">Monitor stock levels and get restock recommendations</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Promotion Enrollment</h3>
                  <p className="text-sm text-blue-200">Easily enroll your products in marketplace promotions</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Financial Insights</h3>
                  <p className="text-sm text-blue-200">Track revenue, reconciliation, and profitability metrics</p>
                </div>
              </div>

              <div className="flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-blue-500/20 flex items-center justify-center flex-shrink-0">
                  <svg className="w-5 h-5 text-blue-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
                <div>
                  <h3 className="font-semibold text-white mb-1">Easy Product Onboarding</h3>
                  <p className="text-sm text-blue-200">Connect with Shopify and WooCommerce for seamless catalog sync</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="text-blue-200 text-sm">
          © 2025 GlobalBridge. All rights reserved.
        </div>
      </div>

      {/* Right Side - Sign In Form */}
      <div className="flex-1 flex items-center justify-center p-4 sm:p-8 bg-gray-50">
        <div className="w-full max-w-md">
          {/* Mobile Logo — navy chip so white logo is visible on light bg */}
          <div className="lg:hidden mb-8 flex justify-center">
            <div className="inline-flex items-center justify-center bg-brand-navy rounded-xl px-5 py-3">
              <img
                src="https://static.wixstatic.com/media/28bda8_155c86a5b5f341c7839ba26980f0aea4~mv2.png/v1/fill/w_276,h_128,al_c,q_85,usm_0.66_1.00_0.01,enc_avif,quality_auto/GB%20logo%20copy.png"
                alt="GlobalBridge"
                className="h-10 object-contain mix-blend-lighten brightness-200"
              />
            </div>
          </div>

          <div className="mb-8 text-center">
            <h2 className="text-3xl font-bold text-gray-900 mb-2">Sign in to your account</h2>
            <p className="text-gray-600">Enter your credentials to access your dashboard</p>
          </div>

          <ClerkSignIn
            appearance={{
              variables: {
                colorPrimary: '#031A42',
                colorBackground: '#ffffff',
                colorText: '#1f2937',
                colorInputBackground: '#f9fafb',
                colorInputText: '#1f2937',
                borderRadius: '0.75rem',
                fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
              },
              elements: {
                rootBox: 'w-full',
                card: 'shadow-xl border border-gray-200 rounded-xl',
                headerTitle: 'hidden',
                headerSubtitle: 'hidden',
                socialButtonsBlockButton: 'border-gray-300 hover:bg-gray-50 transition-colors',
                formButtonPrimary:
                  'bg-brand-navy hover:bg-[#052454] text-white font-semibold py-3 transition-all duration-200 shadow-md hover:shadow-lg',
                formFieldInput:
                  'border-gray-300 focus:border-brand-navy focus:ring-2 focus:ring-brand-navy/20 transition-all',
                footerActionLink: 'text-brand-navy hover:text-[#052454] font-medium',
                identityPreviewEditButton: 'text-brand-navy hover:text-[#052454]',
                formFieldLabel: 'text-gray-700 font-medium',
                dividerLine: 'bg-gray-300',
                dividerText: 'text-gray-500',
                otpCodeFieldInput: 'border-gray-300 focus:border-brand-navy',
              },
              layout: {
                socialButtonsPlacement: 'bottom',
                socialButtonsVariant: 'blockButton',
              },
            }}
            routing="virtual"
            signUpUrl="/sign-up"
            fallbackRedirectUrl="/"
          />
        </div>
      </div>
    </div>
  );
}
